(() => {
    const blocks = document.querySelectorAll('.js-how-work');

    blocks.forEach((block) => {
        const buttons = block.querySelectorAll('.js-how-work-button');
        const content = block.querySelector('.js-how-work-content');

        if (content) {
            buttons.forEach((button) => {
                button.addEventListener('click', () => {
                    content.classList.toggle('hidden');

                    const hasHidden = content.classList.contains('hidden');
                    const { width } = document.body.getBoundingClientRect();
                    const hasMobile = width < 724;

                    if (!hasHidden && hasMobile) {
                        document.body.classList.add('body-lock');
                    } else {
                        document.body.classList.remove('body-lock');
                    }
                });
            });
        }
    });
})();
